module.exports = __webpack_public_path__ + "static/media/zw.4c34708b.svg";